import React, {useState , useEffect} from 'react';
import {Link} from 'react-router-dom';

export default function Notification(props){
    const [values , setValues] = useState({
        link : '',
        id : ''
    })
    const handleNavigation = () => {
        let link , id;
        switch (props.kind) {
            case 'CompanyProfilesNotCompleted':
                link = '/profile';
                break;
            case 'forgetToApply':
                link = '/myJobs';
                id = props.jobId;
                break;
            case 'IsRejected':
                link = '/applications';
                id = props.applicationId;
                break;
            case 'isShortlisted':
                link = '/applications';
                id = props.applicationId;
                break;                
            case 'newApply':
                link = '/applications';
                id = props.applicationId;
                break;
            case 'Postjobs':
                link = '/createJob';
                break;
            case 'RelatedSpecialty':
                link = '/jobs';
                id = props.jobId;
                break;
            case 'userProfilesNotCompleted':
                link = '/profile';
                break;
            case 'viewProfile':
                link = '/companyProfile';
                id = props.companyId;
                break;
            default:
                break;
        }
        setValues({link : link , id : id})
    }
    useEffect(()=>{
        handleNavigation();
    },[])
    return(
        <section key={props.id} id={props.id} className="border-bottom mb-3">
            {/* <Link to={values?.link}> */}
            {/* <header className="bg-orange text-white d-inline-block p-1 pr-2 pl-2 rounded">
               <h6 className="d-inline-block w-auto mb-0"> Reminder</h6>
            </header> */}
            <article className="row m-0">
                <p className="col-md-10 pl-0 mb-1 mt-1">
                    {props.message}
                </p>
                <p className="col-md-2 text-grey text-right pr-0 mb-1 mt-1">
                    {props.createAt}
                </p>
            </article>
            {/* </Link> */}
        </section>
    )
}